module.exports = __webpack_public_path__ + "static/media/old-spring-2021-virtual.c7b96812.png";